import { Card } from "@/components/ui/card";
import gallery1 from "@/assets/gallery-1.jpg";
import gallery2 from "@/assets/gallery-2.jpg";
import gallery3 from "@/assets/gallery-3.jpg";
import gallery4 from "@/assets/gallery-4.jpg";
import gallery5 from "@/assets/gallery-5.jpg";
import gallery6 from "@/assets/gallery-6.jpg";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const Gallery = () => {
  useScrollAnimation();
  const images = [
    { src: gallery1, alt: "Pose d'ardoises sur toiture moderne à Treillières" },
    { src: gallery2, alt: "Démoussage de toiture en cours - Nettoyage professionnel" },
    { src: gallery3, alt: "Installation de couverture zinc, finitions soignées" },
    { src: gallery4, alt: "Ravalement de façade avant/après - Peinture extérieure" },
    { src: gallery5, alt: "Isolation de toiture et combles aménagés" },
    { src: gallery6, alt: "Installation de fenêtre de toit Velux" },
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-background to-background-gray relative overflow-hidden">
      {/* Decorative elements with float animation */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl animate-float"></div>
      
      <div className="container mx-auto relative z-10">
        <div className="text-center mb-16" data-animate>
          <div className="inline-block px-6 py-2 bg-secondary/10 text-secondary font-semibold rounded-full mb-6 text-sm uppercase tracking-wider animate-bounce-in">
            Portfolio
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6 text-primary animate-fade-in">Nos Réalisations</h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed animate-fade-in" style={{ animationDelay: '0.2s' }}>
            Découvrez quelques-unes de nos réalisations de couverture et de rénovation de toiture à Treillières et ses environs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {images.map((image, index) => (
            <Card 
              key={index}
              data-animate
              data-animate-delay={index * 100}
              className="overflow-hidden group cursor-pointer border-0 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-3 hover-glow card-hover"
            >
              <div className="relative aspect-[4/3] overflow-hidden rounded-lg">
                <img
                  src={image.src}
                  alt={image.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-125 group-hover:rotate-2"
                />
                {/* Modern overlay with gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/80 via-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500" />
                
                {/* Shine effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
